import {
    createSlice,
} from '@reduxjs/toolkit';

import {
    clearFreebets,
} from '~Betslip/actions/freeBetsActions';

import {
    addSelection,
    removeSelection,
    clearSelections,
} from '~Betslip/actions/userSelectionsActions';

import {
    editUserMultiple,
} from '~Betslip/actions/userMultiplesActions';

import {
    refreshBetslip,
} from '~Betslip/thunks/refreshBetslip';

import { systemDecimalFormat } from '~Betslip/utils/numberFormatters';

const initialState = [];

const initialMultipleData = {
    stake: 0,
    each_way_selected: false,
    edit: true,
    free_bet_id: null,
};

const userMultiples = createSlice({
    name: 'betslip/userMultiples',
    initialState,
    reducers: {
        removeMultiple: (state, action) => {
            return state.filter(
                multiple => multiple.id !== action.payload
            );
        },
        addUserMultiple: (state, { payload: id }) => {
            const payload = {
                ...initialMultipleData,
                id,
            };

            state.unshift(payload);
        },
        saveFormattedValue: (state, action) => {
            const id = action.payload;

            const multipleToFormat = state.find(multiple => multiple.id === id);
            if (multipleToFormat) {
                const { stake } = multipleToFormat;
                if (stake || stake === '') {
                    Object.assign(multipleToFormat, {
                        stake: systemDecimalFormat(stake),
                    });
                }
            }
        },
        // Dispatching toggleEditor with no payload means the editor will be closed
        toggleEditor: (state, action) => {
            return state
                .filter(({stake, free_bet_id}) => {
                    const stakeIsNotZero = Boolean(Number(stake)) || free_bet_id;

                    return stakeIsNotZero;
                })
                .map(multiple => ({
                    ...multiple,
                    edit: multiple.id === action.payload,
                }));
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(
            editUserMultiple,
            (state, { payload }) => {
                const {
                    id,
                } = payload;

                const multipleToEdit = state.find(multiple => multiple.id === id);
                if (multipleToEdit) {
                    Object.assign(multipleToEdit, payload);
                }
            },
        )
        .addCase(addSelection, () => (initialState))
        .addCase(removeSelection, () => (initialState))
        .addCase(clearSelections, () => (initialState))
        .addCase(
            refreshBetslip.fulfilled,
            (state, action) => {
                const multipleBeingEdited = state.find(multiple => multiple.edit);

                if (multipleBeingEdited) {
                    const { available_bet_types: availableBetTypes } = action.payload;
                    multipleBeingEdited.id = availableBetTypes[availableBetTypes.length - 1].id;
                }
            },
        )
        .addCase(
            clearFreebets,
            (state) => (state.filter(({free_bet_id}) => free_bet_id === null)),
        );
    },
});

export const {
    removeMultiple,
    addUserMultiple,
    saveFormattedValue,
    toggleEditor,
} = userMultiples.actions;

export default userMultiples.reducer;
